import { Component, OnInit, ViewChild } from '@angular/core';import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from '../../../shared/services/hr/publicSetting';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';

@Component({
  selector: 'app-extra-time-rule-header-system',
  templateUrl: './extra-time-rule-header-system.component.html',
  styleUrls: ['./extra-time-rule-header-system.component.scss']
})
export class ExtraTimeRuleHeaderSystemComponent implements OnInit {
  button={}
  customDataSource: any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
@ViewChild(DxDataGridComponent) grid:DxDataGridComponent
constructor(public gt:genericCustomStoreService,
  public Objects:ObjectsService,public _publicSettingService:publicSettingService,public router:Router) {
  this._publicSettingService.submit("ExtraTimeRuleHeaderSystem")
  this.customDataSource =_publicSettingService.customDataSource;  
  this.button=Objects.button;
  this.currentLang = localStorage.getItem(
    this.LOCALIZATION_LOCAL_STORAGE_KEY
  );
}
ngOnInit(): void {
  this._publicSettingService.$ACTIVE_ReFRESH.subscribe(res=>{
  if(res){
  this._publicSettingService.submit("ExtraTimeRuleHeaderSystem")
  this.customDataSource =this._publicSettingService.customDataSource; 
    }
  })
}

ExtraHeaderWorkSystem(e:any){            
  this.router.navigate(['hr/add-edit-ExtraSystem']) 
  this._publicSettingService.$ACTIVE_ID.next(e.key?e.key:0)
}
addrowfun(name:string){
  return this.gt.addrow(name)
}
}
